export const FEATURE_FLAG_LEGISLATION_RESOLUTIONS = "legislationResolutions"
export const LEGISLATION_RESOLUTIONS_DEMAND = `feature-${FEATURE_FLAG_LEGISLATION_RESOLUTIONS}`
export const LEGISLATION_RESOLUTIONS_PAGE_DEMANDS = ["user", "!sharing", LEGISLATION_RESOLUTIONS_DEMAND]
